import { useState } from 'react';
import { login } from './api';

export default function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await login(email, password);
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('user', JSON.stringify({
        username: data.username,
        email:    data.email,
        is_admin: data.is_admin,
      }));
      onLogin(data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0a0a0a'}}>
      <div style={{width:'100%',maxWidth:'400px',padding:'0 20px'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <h1 style={{color:'#00ff88',fontSize:'2rem',fontWeight:'bold',margin:0}}>⚡ KINETIC BOS</h1>
          <p style={{color:'#888',marginTop:'8px',fontSize:'0.875rem'}}>Automated NQ Futures Trading</p>
        </div>
        <div style={{background:'#111',border:'1px solid #222',borderRadius:'8px',padding:'32px'}}>
          <h2 style={{color:'#fff',marginTop:0,marginBottom:'24px'}}>Sign In</h2>
          {error && (
            <div style={{background:'rgba(255,68,68,0.1)',border:'1px solid #ff4444',borderRadius:'4px',padding:'12px',marginBottom:'16px',color:'#ff4444',fontSize:'0.875rem'}}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:'16px'}}>
              <label style={{display:'block',color:'#888',fontSize:'0.75rem',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:'4px'}}>Email</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                style={{width:'100%',background:'#0a0a0a',border:'1px solid #222',borderRadius:'4px',padding:'8px 12px',color:'#fff',fontSize:'0.875rem',boxSizing:'border-box',outline:'none'}}
                placeholder="you@kineticbos.ai" required
              />
            </div>
            <div style={{marginBottom:'24px'}}>
              <label style={{display:'block',color:'#888',fontSize:'0.75rem',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:'4px'}}>Password</label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                style={{width:'100%',background:'#0a0a0a',border:'1px solid #222',borderRadius:'4px',padding:'8px 12px',color:'#fff',fontSize:'0.875rem',boxSizing:'border-box',outline:'none'}}
                placeholder="••••••••" required
              />
            </div>
            <button
              type="submit" disabled={loading}
              style={{width:'100%',background:'#00ff88',color:'#000',fontWeight:'bold',padding:'10px',borderRadius:'4px',border:'none',cursor:loading?'not-allowed':'pointer',opacity:loading?0.5:1,fontSize:'0.875rem'}}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
        <p style={{textAlign:'center',color:'#555',fontSize:'0.75rem',marginTop:'24px'}}>
          kineticbos.ai · Secured with SSL
        </p>
      </div>
    </div>
  );
}
